import { Carousel } from './Carousel';
import { CarouselMediaCard } from './CarouselMediaCard';
import { CarouselSlide } from './CarouselSlide';
import { CarouselContainer } from './Container';

export const CarouselSection = {
  Container: CarouselContainer,
  Carousel,
  CarouselSlide,
  CarouselMediaCard,
};
